import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { getConfiguracoes } from '../lib/supabase'
import Loading from '../components/Loading'

function Secao({ titulo, children }) {
  return (
    <div style={{ marginBottom: '32px' }}>
      <h3 style={{
        fontSize: '16px',
        color: 'var(--cor-principal)',
        marginBottom: '10px',
        paddingBottom: '8px',
        borderBottom: '1px solid var(--cor-borda)',
      }}>
        {titulo}
      </h3>
      <div style={{ color: 'var(--cor-texto)', fontSize: '14px', lineHeight: 1.8 }}>
        {children}
      </div>
    </div>
  )
}

function DireitoItem({ titulo, descricao }) {
  return (
    <div style={{ marginBottom: '10px' }}>
      <strong style={{ color: 'var(--cor-principal)' }}>{titulo}:</strong>{' '}
      <span style={{ color: 'var(--cor-texto-suave)' }}>{descricao}</span>
    </div>
  )
}

export default function PoliticaPrivacidade() {
  const [cfg, setCfg] = useState(null)
  const [carregando, setCarregando] = useState(true)

  useEffect(() => {
    getConfiguracoes()
      .then(setCfg)
      .catch(console.error)
      .finally(() => setCarregando(false))
  }, [])

  if (carregando) return <div style={{ padding: '64px 24px' }}><Loading /></div>

  const nomeNegocio = cfg?.nome_negocio || ''
  // Responsável pelo tratamento: nome fiscal (Informações do Negócio) é a fonte
  // primária; cai para o nome comercial se ainda não estiver preenchido.
  const responsavelNome = cfg?.nome_fiscal || nomeNegocio || 'o responsável pelo tratamento'
  const nif = cfg?.nif_empresa || ''
  const morada = cfg?.morada || ''
  const responsavelEmail = cfg?.email_contacto || ''
  const finalidade = cfg?.politica_finalidade || ''
  const conservacao = cfg?.politica_conservacao ||
    'Os dados associados a marcações são conservados por um período máximo de 3 anos após a última interação do cliente, salvo obrigação legal, fiscal ou contabilística, ou necessidade de exercício ou defesa de direitos em processo judicial, administrativo ou arbitral.'
  const contactoRgpd = responsavelEmail
  const subcontratantes = cfg?.politica_subcontratantes ||
    'Supabase (infraestrutura de base de dados e backend) · Resend (envio de emails) · Bulkgate (envio de SMS) · Cloudflare (segurança e proteção da plataforma, incluindo o sistema anti-spam Turnstile) · Stripe (processamento de pagamentos, quando aplicável).'
  const textoExtra = cfg?.politica_texto_extra || ''
  const hoje = new Date().toLocaleDateString('pt-PT', { day: '2-digit', month: 'long', year: 'numeric' })

  return (
    <main style={{ maxWidth: '720px', margin: '0 auto', padding: '48px 24px 80px' }}>
      <Link
        to="/"
        style={{ color: 'var(--cor-texto-suave)', fontSize: '13px', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '4px', marginBottom: '32px' }}
      >
        ← Voltar ao início
      </Link>

      <h1 style={{ fontSize: 'clamp(22px, 5vw, 30px)', marginBottom: '8px' }}>
        Política de Privacidade
      </h1>
      <p style={{ color: 'var(--cor-texto-suave)', fontSize: '13px', marginBottom: '40px' }}>
        Última atualização: {hoje}
      </p>

      <div style={{
        background: 'var(--cor-branco)',
        border: '1px solid var(--cor-borda)',
        borderRadius: 'var(--raio-lg)',
        padding: 'clamp(24px, 5vw, 40px)',
        boxShadow: 'var(--sombra)',
      }}>

        <Secao titulo="1. Responsável pelo Tratamento">
          <p>
            O responsável pelo tratamento dos dados pessoais recolhidos através deste website e da
            plataforma de agendamento é <strong>{responsavelNome}</strong>
            {nif && <>, NIF <strong>{nif}</strong></>}
            {morada && <>, com morada em <strong>{morada}</strong></>}.
          </p>
          {responsavelEmail && (
            <p style={{ marginTop: '10px' }}>
              Para assuntos relacionados com proteção de dados, pode entrar em contacto através do
              email <strong>{responsavelEmail}</strong>.
            </p>
          )}
          <p style={{ marginTop: '10px' }}>
            {responsavelNome} determina as finalidades e os meios de tratamento dos dados pessoais
            dos seus clientes, atuando como Responsável pelo Tratamento nos termos do Regulamento (UE)
            2016/679 do Parlamento Europeu e do Conselho («RGPD»).
          </p>
        </Secao>

        <Secao titulo="2. Dados Pessoais Recolhidos">
          <p>
            No âmbito do processo de agendamento e prestação de serviços, poderão ser recolhidos os
            seguintes dados pessoais:
          </p>
          <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
            <li><strong>Nome completo</strong> — identificação do cliente</li>
            <li><strong>Endereço de correio eletrónico</strong> — envio de confirmação e lembretes de marcação</li>
            <li><strong>Número de telefone</strong> — contacto em caso de necessidade (opcional)</li>
            <li><strong>Informações facultativas</strong> inseridas pelo cliente no campo de observações</li>
            <li><strong>Histórico de marcações</strong> e serviços agendados</li>
            <li><strong>Dados técnicos</strong> necessários ao funcionamento e segurança da plataforma</li>
          </ul>
          <p style={{ marginTop: '10px' }}>
            O serviço destina-se a maiores de 18 anos. Quando a marcação diga respeito a um menor, os
            dados são tratados com base no consentimento do respetivo representante legal (ver ponto 3).
          </p>
          <p style={{ marginTop: '10px' }}>
            Não solicitamos nem pretendemos recolher categorias especiais de dados pessoais
            (designadamente dados relativos à saúde, origem racial ou étnica, opiniões políticas,
            convicções religiosas ou filosóficas, filiação sindical, dados genéticos ou biométricos, ou
            dados relativos à vida sexual). Caso o cliente introduza voluntariamente este tipo de
            informação nos campos livres, tal tratamento ocorrerá exclusivamente na medida necessária à
            prestação do serviço solicitado.
          </p>
        </Secao>

        <Secao titulo="3. Menores de Idade">
          <p>
            Os serviços disponibilizados destinam-se preferencialmente a pessoas com idade igual ou
            superior a 18 anos. Sempre que uma marcação disser respeito a um menor de idade, os dados
            pessoais deverão ser fornecidos ou autorizados pelo respetivo representante legal, que
            assume a responsabilidade pela licitude da comunicação dos dados e dos consentimentos
            eventualmente necessários.
          </p>
        </Secao>

        <Secao titulo="4. Finalidades do Tratamento">
          {finalidade && <p style={{ marginBottom: '10px' }}>{finalidade}</p>}
          <p>Os dados pessoais são tratados para as seguintes finalidades:</p>
          <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
            <li><strong>Gestão de marcações</strong> — criação, alteração e cancelamento de marcações; envio de confirmações e lembretes; gestão do histórico de atendimentos</li>
            <li><strong>Prestação dos serviços</strong> — organização e execução dos serviços contratados e respetiva gestão administrativa</li>
            <li><strong>Segurança da plataforma</strong> — prevenção de fraude, spam e utilização abusiva, garantindo a integridade dos serviços digitais</li>
            <li><strong>Comunicações de marketing</strong> — mediante consentimento prévio e expresso, envio de comunicações promocionais, campanhas e novidades relacionadas com a atividade de {responsavelNome}. O consentimento pode ser revogado a qualquer momento</li>
          </ul>
        </Secao>

        <Secao titulo="5. Base Jurídica do Tratamento">
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <p>
              <strong>Execução de contrato</strong> (Art. 6.º, n.º 1, al. b) do RGPD) — tratamento
              necessário para efetuar e gerir marcações, prestar os serviços solicitados e assegurar a
              relação comercial com o cliente.
            </p>
            <p>
              <strong>Consentimento</strong> (Art. 6.º, n.º 1, al. a) do RGPD) — utilizado
              exclusivamente para o envio de comunicações de marketing e para situações em que a
              legislação exija consentimento específico.
            </p>
            <p>
              <strong>Interesse legítimo</strong> (Art. 6.º, n.º 1, al. f) do RGPD) — para garantir a
              segurança da plataforma, prevenir abusos e acessos indevidos, proteger os sistemas
              informáticos e assegurar a gestão eficiente da atividade.
            </p>
          </div>
        </Secao>

        <Secao titulo="6. Conservação dos Dados">
          <p>
            Os dados pessoais são conservados apenas durante o período necessário para cumprir as
            finalidades para que foram recolhidos. {conservacao} Decorrido o prazo aplicável, os dados
            serão eliminados ou anonimizados de forma segura.
          </p>
        </Secao>

        <Secao titulo="7. Os Seus Direitos">
          <p style={{ marginBottom: '12px' }}>
            Nos termos da legislação aplicável, o titular dos dados pode exercer os seguintes direitos:
          </p>
          <DireitoItem titulo="Acesso" descricao="Obter confirmação sobre o tratamento dos seus dados e aceder aos mesmos." />
          <DireitoItem titulo="Retificação" descricao="Solicitar a correção de dados inexatos ou incompletos." />
          <DireitoItem titulo="Eliminação" descricao="Solicitar a eliminação dos seus dados quando aplicável («direito ao esquecimento»)." />
          <DireitoItem titulo="Limitação" descricao="Solicitar a restrição do tratamento em determinadas circunstâncias." />
          <DireitoItem titulo="Portabilidade" descricao="Receber os seus dados num formato estruturado, de uso corrente e leitura automática." />
          <DireitoItem titulo="Oposição" descricao="Opor-se ao tratamento dos seus dados em determinadas situações." />
          <DireitoItem titulo="Revogação do consentimento" descricao="Retirar, a qualquer momento, o consentimento previamente prestado." />
          <DireitoItem titulo="Reclamação" descricao="Apresentar reclamação junto da autoridade de controlo competente." />
        </Secao>

        <Secao titulo="8. Exercício dos Direitos">
          {contactoRgpd ? (
            <p>
              Para exercer qualquer um dos seus direitos, envie um pedido por email para{' '}
              <strong>{contactoRgpd}</strong>. Os pedidos serão analisados e respondidos no prazo
              legalmente previsto, salvo situações de especial complexidade.
            </p>
          ) : (
            <p>
              Para exercer qualquer um dos seus direitos, entre em contacto connosco através dos meios
              disponibilizados na página principal. Os pedidos serão analisados e respondidos no prazo
              legalmente previsto, salvo situações de especial complexidade.
            </p>
          )}
        </Secao>

        <Secao titulo="9. Autoridade de Controlo">
          <p>
            Sem prejuízo de qualquer outro recurso administrativo ou judicial, tem o direito de
            apresentar reclamação junto da{' '}
            <strong>Comissão Nacional de Proteção de Dados (CNPD)</strong>:
          </p>
          <ul style={{ paddingLeft: '20px', marginTop: '10px', color: 'var(--cor-texto-suave)' }}>
            <li>Morada: Av. D. Carlos I, 134, 1.º, 1200-651 Lisboa</li>
            <li>Telefone: 213 928 400</li>
            <li>Email: geral@cnpd.pt</li>
            <li>
              Website:{' '}
              <a
                href="https://www.cnpd.pt"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--cor-principal)' }}
              >
                www.cnpd.pt
              </a>
            </li>
          </ul>
        </Secao>

        <Secao titulo="10. Cookies e Tecnologias">
          <p>
            Este website <strong>não utiliza cookies de rastreamento, publicidade ou
            estatística</strong>. Apenas recorremos a armazenamento local técnico
            (<em>sessionStorage</em>), estritamente necessário ao funcionamento do agendamento — por
            exemplo, para manter os dados da marcação durante o processo. Este armazenamento é apagado
            ao fechar o separador e, por ser essencial, está isento de consentimento prévio.
          </p>
          <p style={{ marginTop: '10px' }}>
            As fontes tipográficas são servidas a partir do próprio site, pelo que não há transferência
            do seu endereço IP para terceiros para esse efeito. O website utiliza ainda o sistema{' '}
            <strong>Cloudflare Turnstile</strong> para prevenção de spam, abuso e acessos automatizados,
            com fundamento no interesse legítimo do responsável pelo tratamento em assegurar a segurança
            da plataforma.
          </p>
        </Secao>

        <Secao titulo="11. Partilha de Dados e Subcontratantes">
          <p>
            Os dados pessoais não são vendidos, alugados ou cedidos a terceiros para fins comerciais.
            Para assegurar a prestação dos serviços, poderão ser utilizados fornecedores especializados
            que tratam dados por nossa conta, atuando como subcontratantes:
          </p>
          <p style={{ marginTop: '10px' }}>{subcontratantes}</p>
          <p style={{ marginTop: '10px' }}>
            Todos os subcontratantes se encontram sujeitos a obrigações contratuais de
            confidencialidade, segurança e proteção de dados.
          </p>
        </Secao>

        <Secao titulo="12. Transferências Internacionais de Dados">
          <p>
            Sempre que algum fornecedor ou subcontratante esteja localizado fora do Espaço Económico
            Europeu, serão adotadas as salvaguardas legalmente exigidas para assegurar um nível adequado
            de proteção dos dados pessoais — nomeadamente decisões de adequação da Comissão Europeia,
            cláusulas contratuais-tipo aprovadas pela Comissão Europeia, ou outros mecanismos legalmente
            previstos.
          </p>
        </Secao>

        <Secao titulo="13. Segurança dos Dados">
          <p>
            {responsavelNome} implementa medidas técnicas e organizativas adequadas para proteger os
            dados pessoais contra perda, destruição, alteração, divulgação, acesso não autorizado ou
            qualquer forma de tratamento ilícito. Estas medidas incluem, entre outras: ligações seguras
            (HTTPS), controlo de acessos e gestão de permissões, monitorização e proteção contra abusos,
            sistemas de autenticação adequados e utilização de fornecedores com elevados padrões de
            segurança.
          </p>
          <p style={{ marginTop: '10px' }}>
            Apesar dos esforços implementados, nenhum sistema de transmissão ou armazenamento eletrónico
            pode ser garantido como absolutamente seguro.
          </p>
        </Secao>

        <Secao titulo="14. Alterações à Política de Privacidade">
          <p>
            A presente Política de Privacidade poderá ser atualizada sempre que necessário para refletir
            alterações legais, operacionais ou tecnológicas. A data da última atualização é indicada no
            topo desta página.
          </p>
        </Secao>

        {textoExtra && (
          <Secao titulo="15. Informações Adicionais">
            <p style={{ whiteSpace: 'pre-line' }}>{textoExtra}</p>
          </Secao>
        )}

      </div>
    </main>
  )
}
